/**
 * @generated SignedSource<<f043f24a3e5dc3dd2199a6f7fd1a2ca1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useWalletTransactionRelayByIdQuery$variables = {
  id: string;
};
export type useWalletTransactionRelayByIdQuery$data = {
  readonly getWalletTransaction: {
    readonly amount: number | null | undefined;
    readonly amountRefunded: number | null | undefined;
    readonly chargeTotal: number | null | undefined;
    readonly createdOn: any;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly oldId: string | null | undefined;
    readonly refundDescription: string | null | undefined;
    readonly refunded: boolean | null | undefined;
    readonly rental: {
      readonly id: string;
    } | null | undefined;
    readonly taxAmount: any | null | undefined;
    readonly taxRate: any | null | undefined;
    readonly type: string | null | undefined;
    readonly user: {
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    } | null | undefined;
  } | null | undefined;
};
export type useWalletTransactionRelayByIdQuery = {
  response: useWalletTransactionRelayByIdQuery$data;
  variables: useWalletTransactionRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "WalletTransaction",
    "kind": "LinkedField",
    "name": "getWalletTransaction",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amountRefunded",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "chargeTotal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refundDescription",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refunded",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taxAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taxRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Rental",
        "kind": "LinkedField",
        "name": "rental",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWalletTransactionRelayByIdQuery",
    "selections": (v2/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWalletTransactionRelayByIdQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d741144327d59bdf7818e30607189c84",
    "id": null,
    "metadata": {},
    "name": "useWalletTransactionRelayByIdQuery",
    "operationKind": "query",
    "text": "query useWalletTransactionRelayByIdQuery(\n  $id: ID!\n) {\n  getWalletTransaction(id: $id) {\n    id\n    oldId\n    amount\n    amountRefunded\n    chargeTotal\n    createdOn\n    description\n    refundDescription\n    refunded\n    taxAmount\n    taxRate\n    type\n    user {\n      id\n      firstName\n      lastName\n    }\n    rental {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "917495169b366fda15ead8ec9983dbb1";

export default node;
